import { render, staticRenderFns } from "./P17PrapaDebtByAreaReport.vue?vue&type=template&id=4a366fbe&"
import script from "./P17PrapaDebtByAreaReport.vue?vue&type=script&lang=js&"
export * from "./P17PrapaDebtByAreaReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports